webpackJsonp([51],{

/***/ "4Sf7":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("G1+p");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("8e9a578e", content, true, {});

/***/ }),

/***/ "G1+p":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}.insight-modal{position:fixed;top:0;bottom:60px;width:100%;z-index:5;background-color:#fff;height:calc(100% - 60px);-webkit-overflow-scrolling:touch;overflow-y:scroll;overflow-x:auto}body.ios .insight-modal{-webkit-transform:translateZ(0);transform:translateZ(0)}@media screen and (min-width:56.875em){.insight-modal{overflow:hidden;top:90px;bottom:0}}.insight-modal__inner{height:calc(100% + 1px)}.insight-modal__iframe{width:100%;height:100%}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/insight/insight-modal/insight-modal.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,eACE,eAAgB,AAChB,MAAO,AACP,YAAa,AACb,WAAY,AACZ,UAAW,AACX,sBAAuB,AACvB,yBAA0B,AAC1B,iCAAkC,AAClC,kBAAmB,AACnB,eAAiB,CAClB,AACD,wBACI,gCAAwC,AAChC,uBAAgC,CAC3C,AACD,uCACA,eACM,gBAAiB,AACjB,SAAU,AACV,QAAU,CACf,CACA,AACD,sBACI,uBAAyB,CAC5B,AACD,uBACI,WAAY,AACZ,WAAa,CAChB","file":"insight-modal.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n.insight-modal {\n  position: fixed;\n  top: 0;\n  bottom: 60px;\n  width: 100%;\n  z-index: 5;\n  background-color: #fff;\n  height: calc(100% - 60px);\n  -webkit-overflow-scrolling: touch;\n  overflow-y: scroll;\n  overflow-x: auto;\n}\nbody.ios .insight-modal {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n}\n@media screen and (min-width: 56.875em) {\n.insight-modal {\n      overflow: hidden;\n      top: 90px;\n      bottom: 0;\n}\n}\n.insight-modal__inner {\n    height: calc(100% + 1px);\n}\n.insight-modal__iframe {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "TJ+c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_modal_js__ = __webpack_require__("pqmg");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e33c59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_modal_vue__ = __webpack_require__("cole");
function injectStyle (ssrContext) {
  __webpack_require__("4Sf7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_insight_modal_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e33c59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insight_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cole":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insight-modal"},[_c('div',{staticClass:"insight-modal__inner"},[_c('content-header',{attrs:{"title":_vm.title,"returnRoute":"home","returnRouteGoTo":"insight-widget"}}),_vm._v(" "),_c('div',{staticClass:"insight-modal__content"},[_c('iframe',{staticClass:"insight-modal__iframe",attrs:{"src":_vm.url,"frameborder":"0"}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pqmg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_generics_content_header_content_header_vue__ = __webpack_require__("Nu5K");


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { contentHeader: __WEBPACK_IMPORTED_MODULE_0__components_generics_content_header_content_header_vue__["a" /* default */] },
  computed: {
    title: function title() {
      return this.url.includes('news.predictit') ? "What's New?" : 'Analysis';
    },
    url: function url() {
      // because atob errors on slug === undefined
      return this.$route.params.slug ? atob(decodeURI(this.$route.params.slug)) : '';
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/51.8191b182ed1965757502.js